import React, { useEffect, useState } from "react";
import { serverHost } from "variables/serverdata.js";
import { Input } from "reactstrap";
const WelcomeStep = (client, selectClient) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [clients, setClients] = useState([]);
  const get_clients = async () => {
    try {
      const token =
        JSON.parse(localStorage.getItem("user") || "{}")?.access_token ||
        localStorage.getItem("token");
      const resp = await fetch(`${serverHost}/fetch_clients`, {
        method: "GET",
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          "Content-Type": "application/json",
        },
      });
      if (!resp.ok) {
        const error = await resp.text();
        console.error("Update failed: ", error);
      }
      const clientData = (await resp.json()).data;
      setClients(clientData);
    } catch {}
  };
  useEffect(() => {
    get_clients();
  }, []);
  const bold = {
    fontWeight: "bold",
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>
          <h2>HusariaOne New Site Setup</h2>
          Welcome to the HusariaOne site setup wizard. <br />
          This process will take approximately{" "}
          <span style={bold}>3 minutes</span>. Please have your new site's{" "}
          <span style={bold}>Name</span>, <span style={bold}>Address</span>, and{" "}
          <span style={bold}>Contact Information</span> ready.
          <br />
          If you would also like to create a new admin user for this site,
          please have their contact information ready as well.
        </div>
      </div>
      {user.user_role === "GLOBAL" ? (
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            marginTop: "1.5rem",
            padding: "0 5.5rem",
          }}
        >
          <label>Select client for new site</label>
          <Input
            id="input-user_role"
            type="select"
            value={client}
            onChange={(e) => selectClient(e.target.value)}
            required
          >
            <option value="">Select Client</option>
            {clients.map((client) => (
              <option key={client.client_uuid} value={client.client_uuid}>
                {client.company_name}
              </option>
            ))}
          </Input>
        </div>
      ) : null}
    </>
  );
};

export default WelcomeStep;
